/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Upload_Error_Parse_HintInputs */

const en_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a different file or build your resume from scratch below.`)
};

const de_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuche eine andere Datei oder erstelle deinen Lebenslauf manuell.`)
};

const fr_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez un autre fichier ou creez votre CV de zero ci-dessous.`)
};

const es_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba con otro archivo o crea tu curriculo desde cero a continuacion.`)
};

const it_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova un altro file o crea il tuo CV da zero qui sotto.`)
};

const nl_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer een ander bestand of maak uw cv hieronder vanaf nul.`)
};

const pl_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprobuj innego pliku lub zbuduj swoje CV od zera ponizej.`)
};

const fi_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokeile toista tiedostoa tai luo ansioluettelosi alusta alkaen alla.`)
};

const da_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv en anden fil eller byg dit CV fra bunden herunder.`)
};

const sv_onboarding_upload_error_parse_hint = /** @type {(inputs: Onboarding_Upload_Error_Parse_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forsok med en annan fil eller bygg ditt CV fran borjan nedan.`)
};

/**
* | output |
* | --- |
* | "Try a different file or build your resume from scratch below." |
*
* @param {Onboarding_Upload_Error_Parse_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_upload_error_parse_hint = /** @type {((inputs?: Onboarding_Upload_Error_Parse_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Upload_Error_Parse_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_upload_error_parse_hint(inputs)
	if (locale === "fr") return fr_onboarding_upload_error_parse_hint(inputs)
	if (locale === "es") return es_onboarding_upload_error_parse_hint(inputs)
	if (locale === "it") return it_onboarding_upload_error_parse_hint(inputs)
	if (locale === "nl") return nl_onboarding_upload_error_parse_hint(inputs)
	if (locale === "pl") return pl_onboarding_upload_error_parse_hint(inputs)
	if (locale === "fi") return fi_onboarding_upload_error_parse_hint(inputs)
	if (locale === "da") return da_onboarding_upload_error_parse_hint(inputs)
	if (locale === "sv") return sv_onboarding_upload_error_parse_hint(inputs)
	return en_onboarding_upload_error_parse_hint(inputs)
});